/*
  © 2017 NetSuite Inc.
  User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
  provided, however, if you are an authorized user with a NetSuite account or log-in, you
  may use this code subject to the terms that govern your access and use.
*/

define('C3.ShoppingExtensions.PDP.CompleteYourKitFunctionality.List.View', [
'Backbone',
'Backbone.CollectionView',
'Backbone.CompositeView',
'jQuery',
'item_relations_cell.tpl',
'item_relations_row.tpl',
'c3_shoppingextensions_pdp_completeyourkit_items.tpl',
'C3.ShoppingExtensions.PDP.CompleteYourKitItems.CellView',
'c3_shoppingextensions_pdp_completeyourkit_list.tpl'

], function (Backbone, 
    BackboneCollectionView,
    CompositeView,
    jQuery,
    item_relations_cell_tpl,
    item_relations_row_tpl,
    c3_shoppingextensions_completeyourkit_items_tpl,
    CompleteYourKitItemsCellView,
    c3_shoppingextensions_pdp_completeyourkit_list_tpl
) {
   return Backbone.View.extend({
    initialize: function (options) {
      CompositeView.add(this);
      this.application = options.application;
      this.collection = options.collection;
      this.configuration = options.configuration;
      this.iteminfo = options.iteminfo;
      this.origin = options.origin;
    },

    childViews: {
      'CompleteYourKit.List':function(){
        return new BackboneCollectionView({
          collection: this.collection,
          viewsPerRow: Infinity,
          cellTemplate: item_relations_cell_tpl,
          rowTemplate: item_relations_row_tpl,
          childView: CompleteYourKitItemsCellView,
          template: c3_shoppingextensions_completeyourkit_items_tpl,
          childViewOptions: {
            origin: this.origin,
            application : this.application,
            configuration : this.configuration,
            container : this.container,
            parentItemInfo : this.iteminfo
          }
        });
      }
    },
    template: c3_shoppingextensions_pdp_completeyourkit_list_tpl,

    getContext: function () {
        return {
          /*homecell:(this.homecell==true)*/
        }
      }
   });
});
